module.exports = __webpack_public_path__ + "media/images/icon__point--gained-77764b212610a2c93c6b4b24650b6f84.png";